import { defineComponent as _defineComponent } from 'vue'
import type { TranslateResult } from 'vue-i18n';
import { Role, LicenseFeature } from '@/modules/shared/types';
import MissingLicenseDlg from '@/modules/shared/components/dialogs/generic/MissingLicenseDlg.vue';
import { computed, ref } from 'vue';
import store from '@/store/store';
import { i18n } from '@/plugins/i18n';
import router from '@/plugins/router';
import { useRoute } from 'vue-router/composables';
import Tabs from '@/components/basics/Tabs.vue';

interface SettingsTab {
    title: string | TranslateResult;
    route: string;
    role?: Role;
    license?: LicenseFeature[];
    order: number;
    category?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsTabs',
  setup(__props) {

const showMissingLicenseDlg = ref<boolean>(false);

const currentRoute = useRoute();

const tabs = computed<SettingsTab[]>(() => router.getRoutes()
    .filter((route) => route.meta.settingsTabs)
    .map((route) => ({
        title: i18n.t(`tab.${route.name}`),
        route: route.name!,
        role: route.meta.role,
        license: route.meta.license,
        order: route.meta.settingsTabsOrder || 100,
        category: route.meta.settingsTabsGroup,
    }))
    .sort((a, b) => a.order - b.order));

const activeTab = computed<SettingsTab|null>(() => tabs.value.find((tab) => tab.route === currentRoute.name) || null);
const tabsForUserRole = computed<SettingsTab[]>(() => tabs.value
    .filter((tab) => !tab.role || store.getters['User/hasRole'](tab.role))
    .filter((tab) => tab.category === activeTab.value?.category));

const disabledTabs = computed<SettingsTab[]>(() => tabsForUserRole.value.filter((tab) => tab.license && !store.getters['User/hasAllFeatureLicenses'](tab.license)));

async function navigate(tab: SettingsTab) {
    await router.push({ name: tab.route });
}

return { __sfc: true,showMissingLicenseDlg, currentRoute, tabs, activeTab, tabsForUserRole, disabledTabs, navigate, MissingLicenseDlg, Tabs }
}

})